import Bugsnag, { Client, Config } from "@bugsnag/js"
import bugsnagReact from "@bugsnag/plugin-react"

let bugsnagClient: Client

export function getOrCreateBugsnagClient(config: Config): Client {
    if (!config.apiKey) {
        // eslint-disable-next-line no-console
        console.warn("No Bugsnag API key provided")
        config.apiKey = "no-key"
    }
    if (!bugsnagClient) {
        bugsnagClient = Bugsnag.createClient({
            ...config,
            plugins: [new bugsnagReact()],
        })
    }

    return bugsnagClient
}
